import i18next from 'i18next'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { baseApi } from 'shared/api/baseApi'
import { fetchApi } from 'shared/api/fetchApi'

export const useLanguageRefetch = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        const handleLanguageChange = () => {
            dispatch(baseApi.util.resetApiState())
            dispatch(fetchApi.util.resetApiState())
        }

        i18next.on('languageChanged', handleLanguageChange)

        return () => {
            i18next.off('languageChanged', handleLanguageChange)
        }
    }, [dispatch])
}
